import { SVGProps, Ref, forwardRef } from 'react';

export const StackoverflowBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.437 15.181h1.955V23H2.8v-7.819h1.955v5.864h13.682z"
            fill="#BBBBBB"
        />
        <path
            d="m6.885 14.6 9.6 2.018.403-1.919-9.6-2.019zm1.27-4.596 8.893 4.141.828-1.778-8.893-4.142zm2.46-4.363 7.54 6.278 1.256-1.508-7.54-6.278zM15.483 1l-1.574 1.171 5.855 7.872 1.574-1.171zM6.71 19.09h9.773v-1.954H6.71z"
            fill="#F58025"
        />
    </svg>
));
StackoverflowBrandSize24Glyph.displayName = 'StackoverflowBrandSize24Glyph';
